import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';
export type FullDimensionName = (typeof apiSlugToDimensionName)[DimensionSlug];

// TODO: check that dimension slugs is the same for cpg and visitation
export const dimensionSlugs = [
  'iol',
  'ds',
  'aud',
  'inv_type',
  'plcmnt',
  'typ',
  'agency',
  'brand',
  'ad',
  'site',
  'channel',
  'publisher',
  'creative',
  'ad_frequency',
  'visit_frequency',
] as const satisfies readonly DimensionSlug[];

export type DimensionSlug = keyof typeof apiSlugToDimensionName;

export const validDimensionSlug = (slug: string): slug is DimensionSlug =>
  slug in apiSlugToDimensionName;

export const convertSlugToDimensionName = (
  slug: DimensionSlug
): FullDimensionName => apiSlugToDimensionName[slug];

export type SubdimensionCounts = Partial<Record<DimensionSlug, number>>;
